// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";



const barChartOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      xAxes: [
        {
          display: true,
          position: "bottom",
          scaleLabel: {
            display: true,
            labelString: "Percent within each position"
          },
          ticks: {
            callback: function(value, index, values) {
              return value + '%';
            }
          }
        }
      ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        //type: 'linear',
        categoryPercentage: 0.5,
        display: true,
        scaleLabel: {
          //rotate: -45,
          display: true,
          labelString: "Position"
        }
      }
    ]
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        let label = data.datasets[tooltipItem.datasetIndex].label || '';
        if (label) {
          label += ': ';
        }
        label += tooltipItem.xLabel + '%';
        return label;
      }
    }
  },
  ticks: {
    autoSkip: false,
    maxRotation: 0,
    minRotation: 90
  },
  title: {
    display: false,
    text: "Transfer Status"
  }
};

interface TransferStatusProps{
  caption: Array<string>;
}

class TransferStatus extends React.Component<TransferStatusProps> {
  constructor(props: TransferStatusProps){
    super(props);
  }
  state = {
    labels: ["Editors", "Paid Staff", "Unpaid contributors", "Intern (hired in fall 2023)", "Intern (hired in winter 2024)"],
    borderWidth: 1,
    datasets: [
      {
        label: "Transfer student from another four-year college",
        data: [(1/61*100).toFixed(2), (0/43*100).toFixed(2), (0/91*100).toFixed(2), (0/51*100).toFixed(2), (2/43*100).toFixed(2)],
        categoryPercentage: 1.0,
        backgroundColor: "#48A2D3"
      },
      {
        label: "Transfer student from a two-year college",
        data: [(2/61*100).toFixed(2), (1/43*100).toFixed(2), (12/91*100).toFixed(2), (7/51*100).toFixed(2), (5/43*100).toFixed(2)],
        categoryPercentage: 1.0,
        backgroundColor: 'green'
      },
      {
        label: "Non-transfer student",
        data: [(57/61*100).toFixed(2), (42/43*100).toFixed(2), (77/91*100).toFixed(2), (43/51*100).toFixed(2), (36/43*100).toFixed(2)],
        categoryPercentage: 1.0,
        backgroundColor: "#F0A202"
      },
      {
        label: "Prefer not to say",
        data: [(1/61*100).toFixed(2), (0/43*100).toFixed(2), (0/91*100).toFixed(2), (1/51*100).toFixed(2), (0/43*100).toFixed(2)],
        categoryPercentage: 1.0,
        backgroundColor: 'gray'
      },
    ]
  };
  
  render() {
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Transfer representation
        </div>
        <div
          className={css`
            height: 600px;
            width: 100%;
          `}
        >
          <HorizontalBar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
            {caption}
        </div>
      </Card>
    );
  }
}

export default TransferStatus;
